import type { StackAppearance } from '@unifyapps/defs/blocks/Stack/types';

export const getDirection = (appearance: StackAppearance | undefined) => {
  if (appearance?.reverseOrder) {
    return appearance.direction === 'row' ? 'row-reverse' : 'column-reverse';
  }
  return appearance?.direction;
};
